// Contador "cuántas imágenes generar". Vive como una celda más de los ajustes rápidos
// (`AjustesRapidosProducto`), al lado de Calidad, Fondo y Formato.
//
// Por eso no trae caja propia: la celda ya pone el fondo, el radio y la etiqueta. Lo que
// se dibuja acá es sólo el control, con la misma pastilla gris y los mismos botones
// blancos que el selector de Calidad — son dos controles del mismo rango y tienen que
// leerse igual.
//
// El tope no es un número de este archivo: lo pasa el host, porque cada modo tiene el
// suyo (`autoImageCountMax`) y cambiarlo acá lo desincronizaría del payload y del pill de
// créditos. Se muestra siempre, incluso en 1: la mitad gris es la que dice hasta dónde se
// puede subir, y sin ella el "+" parece infinito.

import React from 'react';
import { Minus, Plus } from 'lucide-react';

export interface ContadorImagenesProps {
  valor: number;
  max: number;
  onChange: (v: number) => void;
  /** Sin selección de producto el contador se ve pero no se toca — igual que el CTA del
   *  pie, que tampoco se puede apretar todavía. */
  disabled?: boolean;
}

export const ContadorImagenes: React.FC<ContadorImagenesProps> = ({
  valor,
  max,
  onChange,
  disabled = false,
}) => {
  const boton =
    'shrink-0 w-7 h-7 inline-flex items-center justify-center rounded-md bg-white text-brand-black/70 shadow-sm hover:text-brand-black disabled:opacity-30 disabled:cursor-not-allowed disabled:shadow-none disabled:bg-transparent transition-colors';
  return (
    <span className="mt-1 flex items-center gap-0.5 p-0.5 rounded-lg bg-black/[0.05]">
      <button
        type="button"
        aria-label="Una imagen menos"
        onClick={() => onChange(Math.max(1, valor - 1))}
        disabled={disabled || valor <= 1}
        className={boton}
      >
        <Minus className="w-3.5 h-3.5" />
      </button>
      {/* El valor se queda con el aire del medio (`flex-1`): así los dos botones quedan
          pegados a los extremos de la celda midan lo que midan las etiquetas. */}
      <span className="flex-1 min-w-0 text-center text-[12.5px] leading-none tabular-nums">
        <span className="font-semibold text-brand-black/90">{valor}</span>
        <span className="text-[#3C3C43]/45">/{max}</span>
      </span>
      <button
        type="button"
        aria-label="Una imagen más"
        onClick={() => onChange(Math.min(max, valor + 1))}
        disabled={disabled || valor >= max}
        className={boton}
      >
        <Plus className="w-3.5 h-3.5" />
      </button>
    </span>
  );
};
